export default __webpack_public_path__ + "static/media/Type 14.ab51e48f.jpg";